import { ContextTypes } from "api/model/dashboard/DashboardTab";
import { ChronoUnitLegacy } from "utils/time-utils";

export const defaultYearsSelectionConfig = {
  alignStartTo: ChronoUnitLegacy.YEARS,
  lag: 0,
  lagUnit: ChronoUnitLegacy.YEARS,
  lead: 1,
  leadUnit: ChronoUnitLegacy.YEARS,
  timeOffset: 0,
  timeOffsetUnit: ChronoUnitLegacy.YEARS,
};

export const defaultRangeDateConfig = {
  alignStartTo: ChronoUnitLegacy.HOURS,
  lag: 0,
  lagUnit: ChronoUnitLegacy.HOURS,
  lead: 0,
  leadUnit: ChronoUnitLegacy.HOURS,
  timeOffset: 0,
  timeOffsetUnit: ChronoUnitLegacy.HOURS,
};

export const defaultSingleDateSelectionConfig = {
  alignStartTo: ChronoUnitLegacy.HOURS,
  timeOffset: 0,
  timeOffsetUnit: ChronoUnitLegacy.HOURS,
};

export const defaultTabContextConfig = {
  contextType: ContextTypes.NONE,
  showBorders: false,
  referenceTime: undefined,
  config: undefined,
};
